module.exports = __webpack_public_path__ + "static/media/realtimeDashboread.f5749b5b.png";